export enum AccountEnum {
  Account = 'account',
  AccountDetails = 'details',
  AccountSettings = 'settings',
  AccountEventTickets = 'event-tickets',
  AccountActivity = 'activity',
  AccountRaffleTickets = 'raffle-tickets',
  AccountBilling = 'billing',
  AccountVouchers = 'vouchers',
  AccountPrivacyPolicy = 'privacy-policy',
}
